import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HRVLogPage = lazy(() => import("./HRVLogPage.tsx"));

const HRVLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HRVLogPage />
    </Suspense>
  );
};

export default HRVLogPageLazy;
